import React from "react";
import { 
  useTheme, 
  Box, 
  Typography, 
  IconButton 
} from "@mui/material";
import { EditOutlined, DeleteOutlined } from "@mui/icons-material";
import Dropzone from "react-dropzone";
import toast from "react-hot-toast";
import FlexBetween from "components/FlexBetween";


const DropzoneComponent = ({ image, setImage }) => {
  const { palette } = useTheme();

  const handleDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (!["image/jpeg", "image/png"].includes(file.type)) {
      toast.error("Only JPG/PNG allowed.");
      return;
    }
    setImage(file);
  };

  return (
    <Dropzone acceptedFiles=".jpg,.jpeg,.png" multiple={false} onDrop={handleDrop}>
      {({ getRootProps, getInputProps }) => (
        <FlexBetween>
          <Box
            {...getRootProps()}
            width="100%"
            border={`2px dashed ${palette.primary.main}`}
            p="1rem"
            sx={{ "&:hover": { cursor: "pointer" } }}
          >
            <input {...getInputProps()} />
            {!image ? (
              <p>Add Image Here</p>
            ) : (
              <FlexBetween>
                <Typography>{image.name}</Typography>
                <EditOutlined />
              </FlexBetween>
            )}
          </Box>
          {image && (
            <IconButton onClick={() => setImage(null)} sx={{ width: "15%" }}>
              <DeleteOutlined />
            </IconButton>
          )}
        </FlexBetween>
      )}
    </Dropzone>
  );
};

export default DropzoneComponent;
